export default __webpack_public_path__ + "static/Ali. zeeshan-92c7e2fdebbb6f3f811bc72d850ae897.jpg";